import template from './topdata-reg-attempt-log-list.html.twig';

const { Mixin } = Shopware;
const { Criteria } = Shopware.Data;
const { date } = Shopware.Utils.format;

Shopware.Component.register('topdata-reg-attempt-log-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            naturalSorting: false,
            total: 0,
            filterAttemptType: null,
            filterConflictType: null,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcl_registration_attempt_log');
        },

        listFilters() {
            return [
                {
                    property: 'attemptType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.filter.attemptType'),
                    options: [
                        { value: null, label: this.$tc('global.default.all') },
                        { value: 'guest_checkout', label: this.$tc('TopdataContactLoginSW6.regLog.attemptType.guest_checkout') },
                        { value: 'registration', label: this.$tc('TopdataContactLoginSW6.regLog.attemptType.registration') },
                        { value: 'contact_create', label: this.$tc('TopdataContactLoginSW6.regLog.attemptType.contact_create') },
                        { value: 'contact_email_change', label: this.$tc('TopdataContactLoginSW6.regLog.attemptType.contact_email_change') },
                    ],
                },
                {
                    property: 'conflictType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.filter.conflictType'),
                    options: [
                        { value: null, label: this.$tc('global.default.all') },
                        { value: 'customer_exists', label: this.$tc('TopdataContactLoginSW6.regLog.conflictType.customer_exists') },
                        { value: 'contact_exists', label: this.$tc('TopdataContactLoginSW6.regLog.conflictType.contact_exists') },
                    ],
                },
            ];
        },

        columns() {
            return [
                {
                    property: 'email',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.email'),
                    allowResize: true,
                    primary: true,
                },
                {
                    property: 'attemptType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.attemptType'),
                    allowResize: true,
                },
                {
                    property: 'conflictType',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.conflictType'),
                    allowResize: true,
                },
                {
                    property: 'createdAt',
                    label: this.$tc('TopdataContactLoginSW6.regLog.list.column.createdAt'),
                    allowResize: true,
                },
            ];
        },
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('customer');

            if (this.filterAttemptType) {
                criteria.addFilter(Criteria.equals('attemptType', this.filterAttemptType));
            }

            if (this.filterConflictType) {
                criteria.addFilter(Criteria.equals('conflictType', this.filterConflictType));
            }

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onFiltersChanged(filters) {
            this.filterAttemptType = filters.attemptType || null;
            this.filterConflictType = filters.conflictType || null;
            this.getList();
        },

        getAttemptTypeLabel(attemptType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.attemptType.${attemptType}`, 0, attemptType);
        },

        getConflictTypeLabel(conflictType) {
            return this.$tc(`TopdataContactLoginSW6.regLog.conflictType.${conflictType}`, 0, conflictType);
        },

        getConflictTypeVariant(conflictType) {
            const variants = {
                customer_exists: 'danger',
                contact_exists: 'warning',
            };
            return variants[conflictType] || 'info';
        },

        formatDate(value) {
            if (!value) {
                return '';
            }
            return date(value, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        },
    },
});
